<template>
    <v-container
        v-if="$vuetify.breakpoint.width > 0"
        fluid
        :class="`pa-0 ${
            page && page.slug && page.slug.en && page.slug.en.current
                ? page.slug.en.current
                : ''
        }`"
    >
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12">
                <DynamicSnackbar />
                <!-- <Hero :show="showHero" /> -->
                <Breadcrumbs
                    v-if="page && page.slug && page.slug.en.current !== 'home'"
                    :page="page"
                />
                <Heading
                    v-if="
                        page &&
                        page._id &&
                        !page.hideHeading &&
                        page.slug.en.current !== 'shop'
                    "
                    :page="page"
                    :template="template"
                />
                <Content
                    v-if="page && page._id && page.contentSections"
                    :page="page"
                    :template="template"
                />
                <Resource
                    v-if="page && page._id && page._type === 'resource'"
                    :page="page"
                    :template="template"
                />
                <ContentCategories
                    v-if="
                        page &&
                        page._type === 'category' &&
                        page.subcategories &&
                        page.subcategories.length > 0
                    "
                    :page="page"
                    :loader="hasLoader"
                />
                <BulkOrderPad
                    v-if="
                        page &&
                        page._id &&
                        page.slug.en.current === 'quick-order-pad'
                    "
                />
                <Footer :show="showFooter" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Breadcrumbs from '~/components/Breadcrumbs.vue'
import Content from '~/components/Content.vue'
import ContentCategories from '~/components/ContentCategories.vue'
import DynamicSnackbar from '~/components/DynamicSnackbar.vue'
import Footer from '~/components/Footer.vue'
import Heading from '~/components/Heading.vue'
import BulkOrderPad from '~/components/BulkOrderPad.vue'
import Resource from '~/components/Resource.vue'

export default {
    name: 'TemplateDefault',
    components: {
        Breadcrumbs,
        Content,
        ContentCategories,
        DynamicSnackbar,
        Footer,
        Heading,
        Resource,
        BulkOrderPad,
    },
    props: {
        page: {
            type: Object,
            default: null,
        },
        template: {
            type: String,
            default: 'Default',
        },
    },
    data() {
        return {
            showHero: false,
            showFooter: true,
            hasLoader: true,
            webusers: [],
        }
    },
    computed: {
        debugData() {
            return {
                template: this.template,
                error: this.error,
            }
        },
    },
    mounted() {
        this.endLoader()
    },
    methods: {
        endLoader() {
            this.hasLoader = false
        },
    },
}
</script>
